import { Action } from 'redux';

export const REDUCER_NAME__DASHBOARD = 'dashboard';
export const REFRESH_DASHBOARD = 'REFRESH_DASHBOARD';
export const REFRESH_DASHBOARD_COMPLETE = 'REFRESH_DASHBOARD_COMPLETE';

export interface DashboardReduxState {
  type?: string;
  loading: boolean;
  isRefreshing: boolean;
  shouldRefresh: boolean;
}

const defaultState: DashboardReduxState = {
  loading: false,
  isRefreshing: false,
  shouldRefresh: false
};

interface DashboardAction extends Action {
  type: string;
}

export default (state: DashboardReduxState = defaultState, action: DashboardAction): DashboardReduxState => {
  switch (action.type) {
    case REFRESH_DASHBOARD:
      return {
        ...state,
        shouldRefresh: true
      };
    case REFRESH_DASHBOARD_COMPLETE:
      return {
        ...state,
        shouldRefresh: false
      };
    default:
      return state;
  }
};
